import { render, staticRenderFns } from "./AddMaterialForm.vue?vue&type=template&id=5351a581"
import script from "./AddMaterialForm.vue?vue&type=script&lang=js"
export * from "./AddMaterialForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports